import {
  FaEdit,
  FaTrash,
  FaLock,
  FaUnlock,
} from "react-icons/fa";

export default function ProductoTable({
  productos,
  loading,
  onEditar,
  onEliminar,
  onToggleEstado,
}) {

  const formatCOP = (valor) =>
    Number(valor || 0).toLocaleString("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
    });

  const calcularMargen = (precio, costo) => {
    if (!precio || precio === 0) return 0;
    return ((precio - costo) / precio) * 100;
  };

  return (
    <div className="mt-2 rounded-xl border border-slate-200 dark:border-slate-800">
      <div className="w-full overflow-x-auto">
        <table className="w-full min-w-[1000px] text-sm">
          <thead className="bg-slate-100 dark:bg-slate-950/80">
            <tr>
              <th className="px-4 py-2 text-left">ID</th>
              <th className="px-4 py-2 text-left">Nombre</th>
              <th className="px-4 py-2 text-center">Categoría</th>
              <th className="px-4 py-2 text-center">Precio</th>
              <th className="px-4 py-2 text-center">Costo</th>
              <th className="px-4 py-2 text-center">Ganancia</th>
              <th className="px-4 py-2 text-center">Margen</th>
              <th className="px-4 py-2 text-center">Estado</th>
              <th className="px-4 py-2 text-center">Acciones</th>
            </tr>
          </thead>

          <tbody>
            {productos.length === 0 ? (
              <tr>
                <td colSpan="9" className="px-4 py-4 text-center">
                  {loading
                    ? "Cargando productos..."
                    : "No se encontraron productos"}
                </td>
              </tr>
            ) : (
              productos.map((p) => {
                const ganancia = (p.precio || 0) - (p.costo || 0);
                const margen = calcularMargen(p.precio, p.costo);

                let badgeColor = "bg-emerald-500";
                if (margen < 15) badgeColor = "bg-rose-500";
                else if (margen < 30) badgeColor = "bg-amber-500";

                return (
                  <tr
                    key={p.id}
                    className="odd:bg-white even:bg-slate-50
                               dark:odd:bg-slate-900/60 dark:even:bg-slate-900/40
                               hover:bg-slate-100 dark:hover:bg-slate-800"
                  >
                    <td className="px-4 py-2">{p.id}</td>

                    <td className="px-4 py-2 font-medium">{p.nombre}</td>

                    <td className="px-4 py-2 text-center">
                      {p.categoria?.nombre || "—"}
                    </td>

                    <td className="px-4 py-2 text-center font-semibold">
                      {formatCOP(p.precio)}
                    </td>

                    <td className="px-4 py-2 text-center">
                      {formatCOP(p.costo)}
                    </td>

                    <td className={`px-4 py-2 text-center font-semibold ${
                      ganancia >= 0
                        ? "text-emerald-600"
                        : "text-rose-600"
                    }`}>
                      {formatCOP(ganancia)}
                    </td>

                    <td className="px-4 py-2 text-center">
                      <span
                        className={`px-2 py-1 rounded-full text-white text-xs font-semibold ${badgeColor}`}
                      >
                        {margen.toFixed(1)}%
                      </span>
                    </td>

                    <td className="px-4 py-2 text-center">
                      {!p.bloqueado ? (
                        <span className="text-emerald-500">🟢 Disponible</span>
                      ) : (
                        <span className="text-rose-400">🔴 Bloqueado</span>
                      )}
                    </td>

                    <td className="px-4 py-2 text-center">
                      <div className="flex flex-wrap justify-center gap-2">
                        <button
                          onClick={() => onEditar(p)}
                          className="inline-flex items-center gap-2 px-3 py-1.5
                                     rounded-lg text-xs font-medium
                                     border border-sky-500 text-sky-300
                                     hover:bg-sky-500 hover:text-slate-900"
                        >
                          <FaEdit />
                          Editar
                        </button>

                        <button
                          onClick={() => onToggleEstado(p)}
                          className={`inline-flex items-center gap-2 px-3 py-1.5
                                     rounded-lg text-xs font-medium border transition-colors ${
                            !p.bloqueado
                              ? "border-amber-500 text-amber-300 hover:bg-amber-500 hover:text-slate-900"
                              : "border-emerald-500 text-emerald-300 hover:bg-emerald-500 hover:text-slate-900"
                          }`}
                        >
                          {!p.bloqueado ? <FaLock /> : <FaUnlock />}
                          {!p.bloqueado ? "Bloquear" : "Desbloquear"}
                        </button>

                        <button
                          onClick={() => onEliminar(p.id)}
                          className="inline-flex items-center gap-2 px-3 py-1.5
                                     rounded-lg text-xs font-medium
                                     border border-rose-500 text-rose-300
                                     hover:bg-rose-500 hover:text-slate-900"
                        >
                          <FaTrash />
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}